import { create } from 'zustand'

export interface DocumentSharePdf {
  bytes: Uint8Array
  filename: string
}

export interface PendingDocumentShare {
  documentId: string
  kindLabel: string
  patientName?: string
  signed: boolean
  phoneE164?: string | null
  filename?: string
  /** Gera somente a via sem assinatura; a via assinada vem do Storage. */
  loadPdf?: () => Promise<DocumentSharePdf>
  /** Abre a assinatura por cima da folha de compartilhar. */
  onSign?: () => void
}

interface DocumentShareStoreState {
  pending: PendingDocumentShare | null
  present: (pending: PendingDocumentShare) => void
  dismiss: () => void
}

export const useDocumentShareStore = create<DocumentShareStoreState>((set) => ({
  pending: null,
  present: (pending) => set({ pending: { ...pending } }),
  dismiss: () => set({ pending: null }),
}))

export const openDocumentShare = (pending: PendingDocumentShare): void => {
  useDocumentShareStore.getState().present(pending)
}
